<div *ngIf="show" class="upgrade {{css}}" [class.simple]="isSimple" (click)="showUpgradeModal()">
    <span *ngIf="!isSimple" class="upgrade-inner">UPGRADE</span>
    <mat-icon *ngIf="isSimple" class="upgrade-inner">publish</mat-icon>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/upgrade.button/upgrade.button.component.html